import { Fragment, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';

const SolarEnergySolutions = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving');
    const [active, setActive] = useState(0);
    const [imgActive, setImgActive] = useState(0);
    const solarEnergyRef = useRef<HTMLDivElement>(null);
    const tabs = [
        {
            title: t(`solar_energy_card1_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749000740150/solarEnergy_pc_1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749000739617/solarEnergy_h5_1.jpg',
            },
            id: '#solarEnergy',
        },
        {
            title: t(`solar_energy_card2_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749000740565/solarEnergy_pc_2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749000739973/solarEnergy_h5_2.jpg',
            },
            id: '#rooftop',
        },
        {
            title: t(`solar_energy_card3_title`),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749000740388/solarEnergy_pc_3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749000739782/solarEnergy_h5_3.jpg',
            },
            id: '#wholeHome',
        },
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = tabs.findIndex((tab) => tab.id === `#${entry.target.id}`);
                        if (index !== -1) {
                            setActive(index);
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px 0px -50% 0px',
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
            },
        );

        tabs.forEach((tab) => {
            const el = document.getElementById(tab.id.replace('#', ''));
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [tabs, setActive]);

    const handleImgClick = (index: number) => {
        setImgActive(index);
    };

    useEffect(() => {}, []);

    return (
        <Fragment>
            {/* <div className={styles['solar-energy-solutions-tabs']}>
                <div className="tabs-container">
                    {tabs.map((item, index) => {
                        return (
                            <a href={item.id} key={item.title} className={`solar-energy-solutions-tab ${active === index ? 'active' : ''}`}>
                                {item.title}
                            </a>
                        );
                    })}
                </div>
            </div> */}
            <div className={styles['solar-energy-solutions']} ref={solarEnergyRef} id="solarEnergy">
                <div className="solar-energy-container">
                    <div className="text-info">
                        <h2>{t('solar_energy_title')}</h2>
                        <p className="desc">{t(`solar_energy_desc`)}</p>
                    </div>
                    <div className="solar-energy-img-container">
                        {tabs.map((item, index) => (
                            <EFPicture
                                key={index}
                                src={item.img.pc}
                                srcMobile={item.img.h5}
                                alt={t('solar_energy_title')}
                                className={`solar-energy-img ${imgActive === index ? 'active' : ''}`}
                            />
                        ))}
                    </div>
                </div>
                <div className="solar-energy-tabs">
                    <div className="tabs-wrapper">
                        <div className="tabs-container">
                            {tabs.map((item, index) => {
                                return (
                                    <div key={item.title} className={`tab ${imgActive === index ? 'active' : ''}`} onClick={(e) => handleImgClick(index)}>
                                        {item.title}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default SolarEnergySolutions;
